module.exports = __webpack_public_path__ + "img/gtv.5c5e57ee.svg";